/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { getQueryApiEndpoint } from '../../Services/Api/EndpointService';

/**
 * Custom useBestFitQuery hook
 * @param apiEndpointKey
 * @param queryVariables
 * @param urlReplaceParameter
 * @param reactQueryOptions
 * @param axiosOptions
 * @returns {UseQueryResult<any, unknown>}
 */
export const useBestFitQuery = (
  apiEndpointKey,
  queryVariables,
  urlReplaceParameter = null,
  reactQueryOptions = {},
  axiosOptions = { headers: { 'content-type': 'application/json' } },
) => useQuery(
  [apiEndpointKey, queryVariables],
  async () => {
    const axiosResponse = await axios.get(getQueryApiEndpoint(apiEndpointKey, urlReplaceParameter), {
      params: queryVariables,
      ...axiosOptions,
    });
    return axiosResponse.data;
  },
  {
    ...reactQueryOptions,
    retry: false,
  },
);
